export const GET_PLC_SAFETY_EVENTS = 'GET_PLC_SAFETY_EVENTS';
export const GET_PLC_SAFETY_EVENTS_SUCCESS = 'GET_PLC_SAFETY_EVENTS_SUCCESS';
export const GET_PLC_SAFETY_EVENTS_ERROR = 'GET_PLC_SAFETY_EVENTS_ERROR';
